














































/* eslint-disable class-methods-use-this */
import PluginComponent from '@/components/plugins/PluginComponent';
import LayerConfig from '@/models/map-context/LayerConfig';
import axios from 'axios';
import { getDocument } from 'ol/xml';
import Component from 'vue-class-component';
import { fromLonLat, toLonLat, transform, transformExtent } from 'ol/proj.js';
import { Feature } from 'ol';
import Point from 'ol/geom/Point';
import { Vector as VectorSource } from 'ol/source';
import { Icon, Style } from 'ol/style';
import { Vector } from 'ol/layer';
import { EVENTS } from '@/services/EventBus';

@Component
export default class PanoramaxPlugin extends PluginComponent {
  static ID = 'PanoramaxPlugin';

  apiKey = '';

  viewer!: any;

  marker: any = null;

  layer: any;

  active = false;

  pnxLayerEnabled = false;

  showInfos=false;

  url = 'https://api.panoramax.xyz';

  onSidebarToggleThrottler: any = null;
  pnxViewerContainer: any;
  pnxViewer: any;
  map: any;
  pnxPicMarker: any;
  pnxPicMarkerLayer: any;
  pnxClickEventId: any;
  pnxDblClickEventId: any;
  pnxLayer: any;
  pnxMapFilters: any;
  delayMapRender: any;

  created(): void {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = 'https://cdn.jsdelivr.net/npm/@panoramax/web-viewer@4.2.0/build/index.css';
    document.head.appendChild(link);
    var tag = document.createElement('script');
    tag.src = 'https://cdn.jsdelivr.net/npm/@panoramax/web-viewer@4.2.0/build/index.js';
    document.head.appendChild(tag);
  }
  mounted(): void {
    console.log('plugin mounted');
    this.apiKey = this.plugin.getParameterValue('api_key'); //<pnx-photo-viewer
    this.map = this.getOpenLayersMapService().map;
   
  }

  expand():void{
    document.getElementById('panoramaxPhotoViewerContainer')?.classList.toggle('pnx-mv-full');
  }
  initPhotoViewer() {
    let _pnxViewerContainer: any = document.getElementById('panoramaxPhotoViewerContainer');
    this.pnxViewerContainer = _pnxViewerContainer;
    this.pnxViewer = document.getElementById('panoramaxPhotoViewer');

    if (!this.pnxViewer) {
      console.error('Panoramax photo viewer is not available');
      return;
    }
    this.pnxViewer.setAttribute('endpoint', 'https://api.panoramax.xyz/api');
    let self = this;

    if (window.innerWidth < 768) {
      document.getElementsByClassName('pnx-mv-toolbar')[0]?.setAttribute('slot', 'top-left');
      document.getElementsByTagName('pnx-widget-player')[0]?.setAttribute('slot', 'top');
    }

    // Picture events

    this.pnxViewer.addEventListener('psv:picture-loading', (e: any) => {
      self.updateGoToPnxLink(e.detail.picId, { x: e.detail.x, y: e.detail.y, z: e.detail.z });
      if (self.pnxLayerEnabled) {
        self.changePicMarker(true, [e.detail.lon, e.detail.lat], e.detail.x);
      }
    });
    this.pnxViewer.addEventListener('psv:picture-loaded', (e: any) => {
      self.updateGoToPnxLink(e.detail.picId, { x: e.detail.x, y: e.detail.y, z: e.detail.z });
      if (self.pnxLayerEnabled) {
        self.changePicMarker(true, [e.detail.lon, e.detail.lat], e.detail.x);
      }
    });
    this.pnxViewer.addEventListener('psv:view-rotated', (e: any) => {
      self.updateGoToPnxLink(this.pnxViewer.psv.getPictureId(), {
        x: e.detail.x,
        y: e.detail.y,
        z: e.detail.z,
      });
      self.changePicMarker(null, null, e.detail.x);
    });

    // Sizing
    /*if (Array.isArray(_config?.picture_size) && _config.picture_size.length == 2) {
      _pnxViewerContainer.style.width = _config.picture_size[0];
      _pnxViewerContainer.style.height = _config.picture_size[1];
    }*/

    // Position
    /*if (_config?.picture_position) {
      _pnxViewerContainer.style.top = _config.picture_position?.top || "unset";
      _pnxViewerContainer.style.bottom = _config.picture_position?.bottom || "unset";
      _pnxViewerContainer.style.right = _config.picture_position?.right || "unset";
      _pnxViewerContainer.style.left = _config.picture_position?.left || "unset";
    }*/

    // Sidebar toggling
    if (window.innerWidth >= 768) {
      self.onSidebarToggle();
      let t: any = document.getElementById('sidebar-wrapper');
      //new ResizeObserver(self.onSidebarToggle).observe(t);
    }
  }

  coordsTo4326(c: any) {
    return transform(c, this.getOpenLayersMapService().mapProjectionCode, 'EPSG:4326');
  }

  /**
   * Transforms EPSG:4326 coordinates into map projection
   * @param {object} c Original WGS84 coordinates
   * @returns {number[]} [lon,lat] coordinates in map projection
   */
  coordsFrom4326(c: any) {
    return transform(c, 'EPSG:4326', this.getOpenLayersMapService().mapProjectionCode);
  }

  /**
   * Generate a bounding box based on coordinates.
   * The bbox allows to search more or less precisely based on map zoom.
   * @param {number[]} coordinate The map coordinates (in EPSG:4326)
   */
  coordsToBbox(coordinate: any) {
    const z = this.map.getView().getZoom();
    const size = Math.min(0.1, Math.max(0.00005, 0.5 / Math.pow(2, z - 5)));

    return [coordinate[0] - size, coordinate[1] - size, coordinate[0] + size, coordinate[1] + size];
  }

  initMapLayer() {

    // Create marker for showing selected picture
    this.pnxPicMarker = new Feature(new Point([0, 0]));
    this.pnxPicMarkerLayer = new Vector({
      source: new VectorSource({ features: [this.pnxPicMarker] }),
      style: new Style({
        image: new Icon({
          // Original image @ https://gitlab.com/panoramax/clients/web-viewer/-/blob/develop/src/img/marker_blue.svg
          src: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgd2lkdGg9IjQ4IgogICBoZWlnaHQ9IjQ4IgogICB2aWV3Qm94PSIwIDAgMTIuNyAxMi43IgogICB2ZXJzaW9uPSIxLjEiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGRlZnMKICAgICBpZD0iZGVmczEiIC8+CiAgPHBhdGgKICAgICBkPSJNLTMuMDA3LS4wMDVhNS45NzggNS45NzggMCAwIDEtNS45NzkgNS45NzhWLS4wMDV6IgogICAgIHN0eWxlPSJmaWxsOiMxYTIzN2U7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlOiNmZmY7c3Ryb2tlLXdpZHRoOjAuNjYxNDU4O3N0cm9rZS1taXRlcmxpbWl0OjQ7c3Ryb2tlLWRhc2hhcnJheTpub25lO3N0cm9rZS1vcGFjaXR5OjEiCiAgICAgdHJhbnNmb3JtPSJyb3RhdGUoLTEzNSkiLz4KICA8Y2lyY2xlCiAgICAgY3g9IjYuMzUiCiAgICAgY3k9IjYuNTQ1IgogICAgIHI9IjIuNjQiCiAgICAgc3R5bGU9ImZpbGw6IzFlODhlNTtmaWxsLW9wYWNpdHk6MTtzdHJva2U6I2ZmZjtzdHJva2Utd2lkdGg6MC42NjAwMjc7c3Ryb2tlLW1pdGVybGltaXQ6NDtzdHJva2UtZGFzaGFycmF5Om5vbmU7c3Ryb2tlLW9wYWNpdHk6MSIgLz4KPC9zdmc+Cg==',
        }),
      }),
      visible: false,
      zIndex: 100,
    });

    // Add to map + listen to click
    this.pnxLayerEnabled = true;
    this.pnxClickEventId = this.map.on('singleclick', this.onCoverageClick);
    this.pnxDblClickEventId = this.map.on('dblclick', () => this.showPictureInViewer());
    this.map.addLayer(this.pnxPicMarkerLayer);

  }

  onCoverageClick(evt: any) {
    let coordinates = this.coordsTo4326(evt.coordinate);
    let bbox = this.coordsToBbox(coordinates);

    // Search for features under click position
    this.pnxLayer.getFeatures(evt.pixel).then((features: any) => {
      const searchOpts: any = {
        limit: 1,
        bbox: bbox.join(','),
      };

      const f = features?.shift();
      if (f) {
        const props = f.getProperties();
        if (props.layer === 'pictures' && props.id) {
          searchOpts.ids = props.id;
        } else if (props.layer === 'sequences' && props.id) {
          searchOpts.collections = props.id;
        }
      }

      // If picture ID is found from map, use it directly
      if (searchOpts.ids) {
        this.showPictureInViewer(searchOpts.ids);
      }
      // Otherwise, launch API call to find best matching picture
      else {
        if (this.map.getView().getZoom() >= 14) {
          searchOpts.sortby = '-ts';
        }

        // Make sure to use appropriate filters as well
        if (this.pnxMapFilters?.pic_type) {
          searchOpts.filter =
            'field_of_view' + (this.pnxMapFilters.pic_type === 'flat' ? '<' : '=') + '360';
        }

        fetch(this.url + '/api/search?' + new URLSearchParams(searchOpts).toString()).then(
          (response) => {
            response.json().then((pnxjson) => {
              const f = pnxjson?.features?.shift();
              if (f) {
                this.showPictureInViewer(f.id, f.collection);
              } else {
                this.showPictureInViewer();
              }
            });
          }
        );
      }
    });
  }

  onSidebarToggle() {
    clearTimeout(this.onSidebarToggleThrottler);
    this.onSidebarToggleThrottler = setTimeout(() => {
      const dragContainer: any = document.getElementById('panoramaxDragContainer');
      dragContainer.style.width = 'calc(100% - 280px)';

      // If viewer goes outside of window, move to left
      const offsets = this.pnxViewerContainer.getBoundingClientRect();
      if (offsets.right > document.body.clientWidth) {
        this.pnxViewerContainer.style.right = '10px';
        this.pnxViewerContainer.style.left = `${document.body.clientWidth - 270 - offsets.width}px`;
      }
      //}
    }, 50);
  }

  changePicMarker(visible: any, coords?: any, orientation?: any) {
    // Change coords
    if (coords) {
      const mapcoords = this.coordsFrom4326(coords);
      this.pnxPicMarker.getGeometry().setCoordinates(mapcoords);
      let pixel = this.map.getPixelFromCoordinate(mapcoords);
      this.map.getView().setCenter(this.map.getCoordinateFromPixel(pixel));
      this.map.getView().setZoom(17);
    }

    // Change orientation
    if (orientation !== null && orientation !== undefined) {
      this.pnxPicMarkerLayer
        .getStyle()
        .getImage()
        .setRotation((orientation * Math.PI) / 180);

      // Hack to force map render to make rotation visible
      clearTimeout(this.delayMapRender);
      this.delayMapRender = setTimeout(() => this.pnxPicMarkerLayer.changed(), 100);
    }

    // Change visibility
    if (visible || visible === false) {
      this.pnxPicMarkerLayer.setVisible(visible);
    }
  }
  showPictureInViewer(picId?: any, seqId?: any) {
    if (picId) {
      if (seqId) {
        this.pnxViewer.setAttribute('sequence', seqId);
      } else {
        this.pnxViewer.removeAttribute('sequence');
      }
      this.pnxViewer.setAttribute('picture', picId);
      this.pnxViewerContainer.style.display = 'unset';
      this.updateGoToPnxLink(picId, this.pnxViewer.psv.getXYZ());
    } else {
      this.pnxViewer.psv.stopSequence();
      this.pnxViewerContainer.style.display = 'none';
      this.changePicMarker(false);
    }
  }
  updateGoToPnxLink(picid: any, xyz: any) {
    const btn: any = document.getElementById('panoramaxOpen');
    if (!btn) {
      return;
    }

    btn.href = `${this.url}/?pic=${picid}&xyz=${xyz.x}/${xyz.y}/${xyz.z}`;
  }

  onClickPanoramax(): void {
    this.active = !this.active;
    if (this.viewer === undefined && this.active) {
      this.initPhotoViewer();
      console.log('plugin mounted');
      this.addPanoramax();
      this.initMapLayer();
    } else {
      this.clear();
    }
  }

  beforeDestroy() {
    if (this.viewer) {
      this.clear();
    }
  }

  close() {
    this.pnxViewerContainer.style.display = 'none';
  }

  clear() {
    this.changePicMarker(false);
    this.showInfos=false;
    this.getEventBus().$emit(EVENTS.ENABLE_SELECTION);
    this.pnxViewerContainer.style.display = 'none';
    this.viewer = undefined;
    this.getMapService().removeLayerFromList(this.layer);
    this.getMapService().removeLayerFromMap(this.layer);
  }

  onPosition(): void {
    this.viewer.getPosition().then((pos: any) => {
      console.log(pos);
      this.marker = this.getMapService().addOverlay([pos.lng, pos.lat]);
    });
  }


  addPanoramax(): void {
    let url = 'https://explore.panoramax.fr/api/map/{z}/{x}/{y}.mvt';
    //this.showInfos=true;
    this.getEventBus().$emit(EVENTS.INFO, 'cliquez sur une ligne orange pour faire apparaitre une photo');
    this.getEventBus().$emit(EVENTS.DISABLE_SELECTION);
    this.getEventBus().$emit(EVENTS.NOTIFICATION, 'La sélection sur la carte est désactivée pendant que le plugin panoramax est actif');
    const selectFunction = (feature: any, popupDiv: any) => {
      let layername = feature.get('layer');
      let imageID = feature.get('image_id');
      let sequence_id = feature.get('first_sequence');
      if (imageID === undefined) {
        imageID = feature.get('id');
      }
      //pictures or sequence
      if (layername == 'sequence') {
        sequence_id = feature.get('id');
        imageID = undefined;
      }
      this.viewer.select(sequence_id, imageID, true);
    };
    let layer = new LayerConfig({
      id: 'panoramax',
      layername: 'geovisio',
      //featureInfoContentRenderer: selectFunction,
      url: url,
      mbStyleUrl: 'https://explore.panoramax.fr/api/map/style.json',
      description: '',
      style: {
        fillStyle: {
          fillSymbol: {},
          fillColor: 'rgba(15,222,111,0)',
          fillPattern: 'simple',
        },
        strokeStyle: {
          symbol: {},
          color: 'rgba(15,222,111,1)',
          strokeWidth: '2',
          pattern: 'simple',
        },
        pointSymbol: {
          symbolStrokeColor: 'rgba(255,255,255,1)',
          symbolFillColor: 'rgba(15,222,111,1)',
        },
        textStyle: { text: '' },
      },
      title: 'Panoramax',
      protocol: 'TMS',
      type: 'VectorTile',
      visible: true,
      boundingBoxEPSG4326: [-175, -85, 175, 85],
    });
    this.getMapService().addLayerToMap(layer);
    this.pnxLayer = layer.getOlLayer();
    this.layer = layer;
  }
}
